<template>
	<div class="task-car-owner">
		<!-- 车主任务 -->
		<nio-header-nav
			position="fixed"
			:is-white="true"
			@back="handleBack"
			:height.sync="headerHeight"
		/>
		<div
			class="main-content"
			:style="{
				paddingTop: headerHeight + 15 + 'px',
				paddingBottom: insetBottom + 'px'
			}"
		>
			<div class="main-content-title">
				车主任务
			</div>
			<div class="main-content-task-list">
				<div
					class="main-content-task-list-block"
					v-for="item in options"
					:key="item.status"
					v-show="item.children.length > 0"
				>
					<div class="top">
						<div :class="`top-dot top-dot__${item.status}`" />
						<div class="top-title">{{ taskStatusMap[item.status] }}</div>
					</div>
					<div class="bottom" v-for="(child, index) in item.children" :key="index">
						<div class="bottom-left">
							<img :src="child.task_picture" alt="" style="height: 68px;width:68px" />
							<div class="bottom-left-content">{{ child.task_name }}</div>
						</div>
						<nio-button
							:text="child.action_name"
							:size="'mini'"
							:round="false"
							type="btn_outline_l"
							:disabled="false"
							@click="goToPage(child)"
						/>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import nativeHybrid from '@/util/nativeHybrid'
import { getSafeInsetBottom } from '@/util/unit-transfer'
import { getOrderTask } from '@/model'
import hybrid from '@/util/nativeHybrid'
import { taskStatusMap } from './conf'
import { supreme } from '@/supreme-core'
import link from '@/util/link'
export default {
	name: 'taskCarOwner',
	data() {
		return {
			taskStatusMap,
			order_no: '',
			headerHeight: 0,
			insetBottom: getSafeInsetBottom(),
			options: [
				{
					status: 2,
					children: []
				},
				{
					status: 1,
					children: []
				},
				{
					status: 3,
					children: []
				}
			]
		}
	},
	created() {
		const orderNo = supreme.getQueryString('order_no')
		if (orderNo) {
			this.order_no = orderNo
			getOrderTask
				.get({ order_no: this.order_no })
				.then(res => {
					console.log(res)
					const { data } = res
					if (!data || data.result_code !== 'success') {
						let error = {}
						error.message = data.debug_msg || data.display_msg || '网络错误'
						throw error
					}
					data.data.map(item => {
						if (item.task_status) {
							const index = this.options.findIndex(i => i.status === item.task_status)
							this.options[index].children.push(item)
						}
					})
					console.log(this.options)
				})
				.catch(error => {
					this.$hideLoading()
					this.$toast(error.message)
				})
		}
	},
	methods: {
		handleBack() {
			nativeHybrid.closeSyn()
		},
		goToPage(child) {
			// link.goToRoute('/carOwnerInfo', {
			// 	order_no: this.order_no,
			// 	task_status: child.task_status
			// })
			// 接口，走的也是 /carOwnerInfo页面路由
			if (child.view_url) {
				hybrid.openURL(child.view_url)
			}
		}
	}
}
</script>
<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';

.task-car-owner {
	font-family: 'PingFang SC';
	::v-deep {
		.nio-button {
			width: 80px;
			height: 35px;
			padding: 0 0;
		}
		.nio-button-text {
			@include body_2(1.5, 400, false);
			color: $text_primary;
		}
	}
	.main-content {
		padding-left: 20px;
		padding-right: 20px;
		padding-bottom: 20px;

		&-title {
			@include headline_1(1.4, 400, false);
			color: $text_primary;
			margin-bottom: 30px;
			&__tips {
				@include subtitle_4(1.5, 400, false);
				color: $text_secondary;
			}
			&__sub {
				@include subtitle_2(1.4, 500);
				color: $text_primary;
				margin-bottom: 20px;
			}
		}
		&-task-list {
			&-block {
				margin-bottom: 40px;
				.top {
					display: flex;
					justify-content: flex-start;
					align-items: center;
					margin-bottom: 20px;
					&-dot {
						width: 6px;
						height: 6px;
						border-radius: 50%;
						&__2 {
							background-color: #25cbc5;
						}
						&__1 {
							background-color: #fab246;
						}
						&__3 {
							background-color: #dbf2f3;
						}
					}
					&-title {
						@include subtitle_4(1.5, 400, false);
						color: $text_primary;
						margin-left: 10px;
					}
				}
				.bottom {
					display: flex;
					justify-content: space-between;
					align-items: center;
					margin-bottom: 15px;
					&-left {
						display: flex;
						justify-content: flex-start;
						align-items: center;
						.pic {
							width: 68px;
							height: 68px;
						}
						&-content {
							@include subtitle_4(1.5, 700, false);
							color: $text_primary;
							margin-left: 15px;
						}
					}
				}
			}
		}
	}
}
</style>
